import type { Theme } from '@mui/material';
import type { Components } from '@mui/material/styles';

import { FONT_STACK } from '../constants/fontface.constant';
import { DESIGN_SYSTEM_COLORS } from '../constants/palette.constant';

export const MuiTableCell = (baseTheme: Theme): Partial<Components> => ({
  MuiTableCell: {
    styleOverrides: {
      root: {
        fontSize: '0.875rem',
        padding: '12px',
        alignItems: 'center',
        borderStyle: 'solid',
        borderWidth: '0 0 1px 1px',
        borderColor: baseTheme.new.color.lineDefault,
        '&:first-of-type': {
          borderLeft: '0px',
        },
      },
      head: {
        backgroundColor: baseTheme.new.color.infoGreyLight,
        fontFamily: FONT_STACK,
        borderWidth: '0 0 1px 1px',
        borderColor: baseTheme.new.color.lineDefault,
        lineHeight: '1.4em',
        [baseTheme.breakpoints.between('lg', 'xl')]: {
          padding: '12px 12px',
        },
        button: {
          padding: '0 0 0 8px',
          color: baseTheme.palette.text.primary,
          fontFamily: FONT_STACK,
          [baseTheme.breakpoints.down('lg')]: {
            fontSize: '0.875rem',
          },
        },
      },
      body: {
        color: baseTheme.palette.text.primary,
        [baseTheme.breakpoints.up('xl')]: {
          maxWidth: '400px',
        },
      },
    },
  },
});

export const MuiTableContainer = (): Partial<Components> => ({
  MuiTableContainer: {
    styleOverrides: {
      root: {
        overflow: 'auto',
      },
    },
  },
});

export const MuiTableRow = (): Partial<Components> => ({
  MuiTableRow: {
    styleOverrides: {
      root: {
        '&.MuiTableRow-hover:hover': {
          backgroundColor: DESIGN_SYSTEM_COLORS.brand[100],
        },
      },
    },
  },
});
